import { DateDiffModel } from 'src/app/models/inputs/date-diff-model';

export class DateModel {
  day: string | number;
  month: string | number;
  year: string | number;
  age?: DateDiffModel;


  constructor(day?: string | number, month?: string | number, year?: string | number) {
    this.day = day;
    this.month = month;
    this.year = year;
  }
}
